import DataConst from 'consts/DataConst';
import BaseController from './BaseController';

class OrderItemController extends BaseController {
  model = DataConst.MODELS.ORDER_ITEM;
}

export default new OrderItemController();
